module.exports = __webpack_public_path__ + "img/img_default_thum_1.33dda594.svg";